import {
  SERVICE_CONSUMER_PROMO,
  SERVICE_EVENT_MARKETING,
  SERVICE_SPORT_MARKETING,
} from "../../../../const/const";
import ServiceCard from "../../service-card-list/service-card";
import "./services-block-content.sass";

type Props = {
  selected: number;
};

const ServicesBlockContent = ({ selected }: Props) => {
  return (
    <div className="services-block-content">
      {selected === 0 && (
        <ServiceCard
          title={SERVICE_EVENT_MARKETING.title}
          name={SERVICE_EVENT_MARKETING.name}
        >
          {SERVICE_EVENT_MARKETING.description}
        </ServiceCard>
      )}

      {selected === 1 && (
        <ServiceCard
          title={SERVICE_SPORT_MARKETING.title}
          name={SERVICE_SPORT_MARKETING.name}
        >
          {SERVICE_SPORT_MARKETING.description}
        </ServiceCard>
      )}

      {selected === 2 && (
        <ServiceCard
          title={SERVICE_CONSUMER_PROMO.title}
          name={SERVICE_CONSUMER_PROMO.name}
        >
          {SERVICE_CONSUMER_PROMO.description}
        </ServiceCard>
      )}
    </div>
  );
};

export default ServicesBlockContent;
